<script>
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import session from '../../lib/session.js';
  import { onMount } from 'svelte';
  import Dialog from '../../lib/components/Dialog.svelte';
  import validate_video_link from '../../lib/validators/video';

  import DialogExperience from './DialogExperience.svelte';

  // component options ------------------------------------------------------ //

  export let input;
  export let experiences;
  export let wait_api;

  // internal variables ------------------------------------------------------ //

  let add_dialog;
  let dialog;
  let dialog_exp;
  let is_video_valid = true;
  let dialog_edit = false;
  let dialog_edit_id = null;
  let dialog_btn = null;
  let form_input = {
    job: null,
    position: null,
    where: null,
    date_current: false,
    date_start_month: null,
    date_start_year: null,
    date_end_month: null,
    date_end_year: null,
    input_value_job: null,
    input_value_start_month: null,
    input_value_start_year: null,
    input_value_end_month: null,
    input_value_end_year: null,

    date_start_month_edit: null,
    date_start_year_edit: null,
    date_end_month_edit: null,
    date_end_year_edit: null,
    description: null,
    video: '',
  };

  // translated strings -------------------------------------------------------- //

  let labels = {
    dialog: {
      title: null,
      content: null,
      title_edit: null,
    },
    btn_cancel: null,
    btn_yes: null,
    tooltip: null,
    title: null,
    type: null,
    where: null,
    no_experience_added: null,
    add_experience: null,
    btn_back: null,
    btn_save: null,
    position: null,
    start_month: null,
    start_year: null,
    end_month: null,
    end_year: null,
    current: null,
    description: null,
    video: null,
    btn_close: null,
    btn_add: null,
  };

  // utility functions -------------------------------------------------------- //

  const delete_list_elem = index => {
    create_delete_dialog(index);
  };

  const delete_from_list = index => {
    let tmp_array = experiences;
    tmp_array.splice(index, 1);
    experiences = tmp_array;
  };

  const init_year_array = () => {
    let tmp_array = [];
    for (let i = 2020; i >= 1970; i--) {
      tmp_array.push({ name: i.toString(), val: i });
    }
    return tmp_array;
  };

  let selectors = {
    jobs: [
      {
        name: t9n('worker_experience_type_job'),
        val: 'worker_experience_type_job',
      },
      {
        name: t9n('worker_experience_type_other'),
        val: 'worker_experience_type_other',
      },
    ],
    date_months: [
      { name: 'January', val: 1 },
      { name: 'February', val: 2 },
      { name: 'March', val: 3 },
      { name: 'April', val: 4 },
      { name: 'May', val: 5 },
      { name: 'June', val: 6 },
      { name: 'July', val: 7 },
      { name: 'August', val: 8 },
      { name: 'September', val: 9 },
      { name: 'October', val: 10 },
      { name: 'November', val: 11 },
      { name: 'December', val: 12 },
    ],
    date_years: init_year_array(),
  };

  const init_share = () => {
    // dialog = new MDCDialog(document.getElementById(`add-dialog`));
  };

  const add_new_experience = () => {
    let new_experience = {
      description: form_input.description,
      end_month: form_input.date_end_month,
      end_year: form_input.date_end_year,
      experience_type: form_input.job,
      is_current: form_input.date_current,
      position: form_input.position,
      start_month: form_input.date_start_month,
      start_year: form_input.date_start_year,
      video_link: form_input.video,
      where: form_input.where,
    };
    let tmp_exp = experiences;
    if (!dialog_edit) {
      tmp_exp.push(new_experience);
    } else {
      for (let i = 0; i < tmp_exp.length; i++) {
        if (i === dialog_edit_id) {
          tmp_exp[i].description = form_input.description;
          tmp_exp[i].end_month = form_input.date_end_month;
          tmp_exp[i].end_year = form_input.date_end_year;
          tmp_exp[i].experience_type = form_input.job;
          tmp_exp[i].is_current = form_input.date_current;
          tmp_exp[i].position = form_input.position;
          tmp_exp[i].start_month = form_input.date_start_month;
          tmp_exp[i].start_year = form_input.date_start_year;
          tmp_exp[i].video_link = form_input.video;
          tmp_exp[i].where = form_input.where;
        }
      }
    }

    close();
    experiences = tmp_exp;
  };

  const validate_video = video => {
    if (video.length === 0) {
      is_video_valid = true;
    } else {
      is_video_valid = validate_video_link(video);
    }
  };

  const create_delete_dialog = index => {
    let target = document.querySelector('.delete-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'delete-message',
        title: labels.dialog.title,
        content: labels.dialog.content,
        buttons: [
          {
            label: labels.btn_cancel,
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: labels.btn_yes,
            action: () => {
              delete_from_list(index);
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    dialog.open();
  };

  const open = index => {
    form_input.date_current = false;

    if (index >= 0) {
      dialog_edit = true;
      dialog_edit_id = index;
      dialog_btn = labels.btn_save;
      for (let i = 0; i < experiences.length; i++) {
        if (i === index) {
          form_input.job = experiences[i].experience_type;
          form_input.position = experiences[i].position;
          form_input.where = experiences[i].where;
          form_input.date_current = experiences[i].is_current;
          form_input.date_start_month = experiences[i].start_month;
          form_input.date_start_year = experiences[i].start_year;
          form_input.date_end_month = experiences[i].end_month;
          form_input.date_end_year = experiences[i].end_year;
          form_input.description = experiences[i].description;
          form_input.video = experiences[i].video_link;

          let start_month_index = form_input.date_start_month - 1;
          let end_month_index = form_input.date_end_month - 1;

          if (start_month_index >= 0) {
            form_input.input_value_start_month =
              selectors.date_months[start_month_index].name;
          } else {
            form_input.input_value_start_month = null;
          }

          if (end_month_index >= 0) {
            form_input.input_value_end_month =
              selectors.date_months[end_month_index].name;
          } else {
            form_input.input_value_end_month = null;
          }

          form_input.input_value_start_year = form_input.date_start_year;

          form_input.input_value_end_year = form_input.date_end_year;

        }
      }
    } else {
      dialog_btn = labels.btn_add;
      dialog_edit = false;
      form_input.job = null;
      form_input.position = null;
      form_input.where = null;
      form_input.date_current = false;
      form_input.date_start_month = null;
      form_input.date_start_year = null;
      form_input.date_end_month = null;
      form_input.date_end_year = null;
      form_input.description = null;
      form_input.video = null;
      form_input.input_value_start_month = null;
      form_input.input_value_start_year = null;
      form_input.input_value_end_month = null;
      form_input.input_value_end_year = null;
      form_input.input_value_job = null;
    }

    let target = document.querySelector('.add-dialog');
    target.innerHTML = '';
    dialog_exp = new DialogExperience({
      target: target,
      props: {
        config: $session,
        dialog_edit: dialog_edit,
        form_input: form_input,
        is_video_valid: is_video_valid,
        add_new_experience: add_new_experience,
        dialog_btn: dialog_btn,
        btn_close: close,
      },
    });
    dialog_exp.open();
  };

  const close = () => {
    dialog_exp.close();
    form_input.date_current = false;
    dialog_edit = false;
  };

  const translate_texts = () => {
    labels.autosave = t9n(TS.NEW_ORDER_AUTO_SAVE);
    labels.dialog.title = t9n(TS.SETTINGS_LABEL_DELETE);
    labels.dialog.content = t9n(TS.TXT_ARE_YOU_SURE);
    labels.btn_cancel = t9n(TS.ORDERER_TEAMS_CANCEL_LABEL);
    labels.btn_yes = t9n(TS.TXT_YES);
    labels.tooltip = t9n(TS.SETTINGS_LABEL_TOOLTIP_EXP);
    labels.title = t9n(TS.SETTINGS_LABEL_TITLE);
    labels.type = t9n(TS.SETTINGS_LABEL_TYPE);
    labels.where = t9n(TS.SETTINGS_LABEL_WHERE);
    labels.no_experience_added = t9n(TS.SETTINGS_LABEL_NO_EXP_ADDED);
    labels.add_experience = t9n(TS.SETTINGS_LABEL_ADD_EXP);
    labels.btn_back = t9n(TS.TXT_BACK);
    labels.btn_save = t9n(TS.CHANGE_PASSWORD_SUBMIT_LABEL);
    labels.position = t9n(TS.SETTINGS_LABEL_POSITION);
    labels.start_month = t9n(TS.SETTINGS_LABEL_START_MONTH);
    labels.start_year = t9n(TS.SETTINGS_LABEL_START_YEAR);
    labels.end_month = t9n(TS.SETTINGS_LABEL_END_MONTH);
    labels.end_year = t9n(TS.SETTINGS_LABEL_END_YEAR);
    labels.current = t9n(TS.SETTINGS_LABEL_CURRENT);
    labels.description = t9n(TS.SETTINGS_LABEL_DESCRIPTION);
    labels.video = t9n(TS.SETTINGS_LABEL_VIDEO);
    labels.btn_close = t9n(TS.LOGIN_FORM_CLOSE);
    labels.btn_add = t9n(TS.ORDERER_TEAMS_ADD_LABEL);
    labels.dialog.title_edit = t9n(TS.SETTINGS_LABEL_EDIT_EXP);
    selectors.date_months[0].name = t9n(TS.SETTINGS_LABEL_MONTH_JAN);
    selectors.date_months[1].name = t9n(TS.SETTINGS_LABEL_MONTH_FEB);
    selectors.date_months[2].name = t9n(TS.SETTINGS_LABEL_MONTH_MAR);
    selectors.date_months[3].name = t9n(TS.SETTINGS_LABEL_MONTH_APR);
    selectors.date_months[4].name = t9n(TS.SETTINGS_LABEL_MONTH_MAY);
    selectors.date_months[5].name = t9n(TS.SETTINGS_LABEL_MONTH_JUN);
    selectors.date_months[6].name = t9n(TS.SETTINGS_LABEL_MONTH_JUL);
    selectors.date_months[7].name = t9n(TS.SETTINGS_LABEL_MONTH_AUG);
    selectors.date_months[8].name = t9n(TS.SETTINGS_LABEL_MONTH_SEP);
    selectors.date_months[9].name = t9n(TS.SETTINGS_LABEL_MONTH_OCT);
    selectors.date_months[10].name = t9n(TS.SETTINGS_LABEL_MONTH_NOV);
    selectors.date_months[11].name = t9n(TS.SETTINGS_LABEL_MONTH_DEC);
    dialog_btn = labels.btn_add;
  };

  // reactive functions -------------------------------------------------------- //

  $: if (form_input.video && !!form_input.video)
    validate_video(form_input.video);

  $: if (!!$session) translate_texts();

  onMount(init_share);
</script>

<div class="margin-24 mobile-margin">
  <!-- Help line -->
  <div id="help-liner" class="">
    <div class="tooltip-default ">
      <span id="tooltip_def" class="tooltip-text tooltip-top">
        {labels.tooltip}
      </span>
    </div>
  </div>

  <!-- Here is the table for experiences -->
  <div id="experiences_panel" style="margin-top: 15px">
    <table id="experiences" class="table">
      <!-- Experiences loop -->
      <tr class="tr-head">
        {#if experiences.length > 0}
          <td class="height" colspan="2">{labels.title}</td>
          <td colspan="1">{labels.type}</td>
          <td colspan="1">{labels.where}</td>
          <td colspan="1" />
        {/if}

        <!-- <td style="vertical-align: bottom; text-align: right"><button class="mdc-button hover" style="color: #bb0000;">{"Remove"}</button></td>-->
      </tr>
      {#if !!experiences}
        {#if experiences.length === 0}
          <tr>
            <td class="height" colspan="2">{labels.no_experience_added}</td>
            <td colspan="1" />
            <td colspan="1" />
            <td colspan="1" />
            <!-- <td style="vertical-align: bottom; text-align: right"><button class="mdc-button hover" style="color: #bb0000;">{"Remove"}</button></td>-->
          </tr>
        {:else}
          {#each experiences as exp, i}
            <tr class="tr-experience">
              <!--                        <tr>-->
              <td
                class="td-resp data-heading where height"
                on:click={() => open(i)}
                colspan="2">
                {exp.position}
              </td>
              <td
                class="td-resp data-heading"
                on:click={() => open(i)}
                colspan="1">
                {t9n(exp.experience_type)}
              </td>
              <td
                class="td-resp data-heading where"
                on:click={() => open(i)}
                colspan="1">
                {exp.where}
              </td>
              <td
                class="td-resp data-heading td-last"
                style="text-align: center"
                on:click={() => delete_list_elem(i)}
                colspan="1">
                <i class="material-icons delete-icon" aria-hidden="true">
                  close
                </i>
              </td>
              <!-- <td style="vertical-align: bottom; text-align: right"><button class="mdc-button hover" style="color: #bb0000;">{"Remove"}</button></td>-->
            </tr>
          {/each}
        {/if}
      {/if}

    </table>

    <!-- Add experiences button -->
    <div style="text-align: left">
      <button
        data-cy="add_experience_button"
        style="margin-right: 10px"
        class="mdc-button mdc-button--raised"
        on:click|stopPropagation|preventDefault={() => open(-1)}>
        {labels.add_experience}
      </button>
    </div>
  </div>

  <!-- Prev / Save buttons -->
  <div style="display: flex; justify-content: flex-end; margin-top: 32px; position: relative;">
<!--    <p class="changes-text">{labels.autosave}</p>-->
    <div style="margin-right: 10px;">
      <button
        onclick="prev_tab()"
        class="mdc-button mdc-button--outlined margin-5">
        <span class="mdc-button__ripple" />
        {labels.btn_back}
      </button>
    </div>

    <button
      onclick="update_profile()"
      disabled={wait_api}
      class="mdc-button mdc-button--unelevated margin-5">
      <span class="mdc-button__ripple" />
      {labels.btn_save}
    </button>
  </div>
  <div class="delete-dialog" />
  <div class="add-dialog" />

  <!-- Hidden 'Add new experience' dialog -->
  <!--    <div class="add-dialog"></div>-->
</div>

<style>
  .changes-text{
    margin-top: 10px;
    margin-right: 10px;
    position: absolute;
    left: 0px;
    opacity: .5;
    font-size: 14px;
  }
  table {
    width: 100%;
    margin-bottom: 15px;
    /*background: #eef0f0;*/
    /*line-height: 2.5;*/
    /*!*padding-left: 15px;*!*/
    /*border-spacing: 0;*/
    background-color: var(--mdc-theme-surface, #fff);
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.12);
    -webkit-overflow-scrolling: touch;
    /*display: inline-flex;*/
    flex-direction: column;
    /*border-collapse: collapse;*/
    border-spacing: 0;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.87);
  }

  .tr-head {
    background-color: blanchedalmond;
  }

  td {
    /*border-bottom: 1px solid #b7b7b7;*/
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    font-family: Roboto, sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    text-transform: inherit;
  }

  .height {
    height: 46px;
  }

  .delete-icon {
    position: relative;
    /*top: -7px;*/
    /*left: 50px;*/
    color: red;
    cursor: pointer;
    vertical-align: bottom;
  }

  h6 {
    font-weight: normal;
    margin-bottom: -50px;
    margin-top: 1px;
  }

  #experiences td {
    /*border: none;*/
    color: #7a7676;
    color: rgba(0, 0, 0, 0.87);
    padding-left: 15px;
    /*border-bottom: 1px solid #b7b7b7;*/
  }

  .label {
    text-align: right;
  }

  .hover:hover {
    background: #f4d1d14d;
    border-radius: 7px;
    height: 33px;
  }

  a:link {
    text-decoration: none;
  }

  .mdc-dialog__surface {
    width: 450px;
  }

  .mdc-layout-grid {
    padding: 0;
  }

  .tr-experience {
    cursor: pointer;
  }

  .where {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /* Tooltip
    *******************************************************/

  .tooltip-default {
    position: relative;
    font-size: 12px;
    /*top: -60px;*/
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    /*position: absolute;*/
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    left: -400px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  .fade-in-long {
    animation: transition_in 2.5s;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .margin-50 {
      margin-left: 50px;
    }

    .padding-50 {
      padding-left: 50px;
    }

    .margin-24 {
      margin-right: 24px;
    }

      .mobile-margin {
          margin-left: 24px;
      }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .mdc-dialog__surface {
      height: 100%;
    }

    .margin-50 {
      margin-left: 50px;
    }

    .padding-50 {
      padding-left: 50px;
    }

    .margin-24 {
      margin-right: 24px;
    }

    .where {
      max-width: 180px;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .margin-50 {
      margin-left: 1px;
    }

    .padding-50 {
      padding-left: 1px;
    }

    .margin-24 {
      margin-right: 1px;
    }

    .mobile-margin {
        margin-left: 43px;
    }

    .mdc-dialog__surface {
      height: 80%;
    }

    table {
      width: 100%;
    }

    .tr-head {
      display: none;
    }

    .tr-experience {
      display: block;
      border-bottom: none;
    }

    .td-resp {
      display: block;
      height: 100%;
      text-align: center;
      border-bottom: none;
    }

    .td-last {
      text-align: center;
      border-bottom: 1px solid #b7b7b7;
    }

    .where {
      /*max-width: 280px;*/
      margin: auto;
    }

    .td-resp:before {
      content: attr(data-heading);
      text-align: center;
    }

    #experiences td {
      /*border-bottom: none;*/
    }

    .delete-icon {
      position: static;
      vertical-align: middle;
    }
  }
</style>
